$invite_dict $mol_page
	title \Rocket Pronunciation
	Head null
	- api_uri \https://aglimakur.beget.app/search?word=
	api_uri \https://raw.githubusercontent.com/Lyumih/invite/master/dict/mock?word=
	body /
		<= Word $mol_labeler
			title <= word_label? \
			content /
				<= Transcription $mol_text text <= transcription? \
	foot /
		<= Search $mol_search query? <=> word? \
